export default "/images/59bd9d10efebc62d29dd9d95548a638e.avif";